import axios, { AxiosResponse } from "axios";

const API_BASE_URL = "/files";
export const DIRECTORY_BASE_PATH = "/input/";

export const downloadConversationApi = async (sessionId: string, language: string): Promise<Blob> => {
    try {
        const response: AxiosResponse<Blob> = await axios.get(`/download_conversation/${sessionId}`, {
            withCredentials: true,
            responseType: "blob",
            params: { language }
        });
        return response.data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.message);
    }
};

export async function generateSasToken(blobPath: string): Promise<string> {
    // Remove / if the blob_path starts with it
    if (blobPath.startsWith("/")) blobPath = blobPath.slice(1);
    return axios
        .get(`${API_BASE_URL}/get_sas_token/${blobPath}`, {
            headers: {
                "Content-Type": "application/json",
                withCredentials: true
            }
        })
        .then(res => {
            const data = res.data;
            return data.office_viewer_url;
        })
        .catch(error => {
            throw error;
        });
}

/**
 * Generates a SAS token for accessing a PDF blob, with support for specifying filename and inline disposition.
 *
 * @async
 * @function generatePDFSasToken
 * @param {string} blobPath - The path of the PDF blob in storage.
 * @param {string} fileName - The desired filename for the PDF when downloaded.
 * @param {boolean} inline - Whether the PDF should be opened inline in the browser (`true`) or downloaded as an attachment (`false`).
 * @returns {Promise<string>} A promise that resolves to the PDF SAS token URL.
 * @throws {Error} If the request to generate the SAS token fails.
 */
export async function generatePDFSasToken(blobPath: string, fileName: string, inline: boolean): Promise<string> {
    // Remove / if the blob_path starts with it
    if (blobPath.startsWith("/")) blobPath = blobPath.slice(1);
    return axios
        .get(`${API_BASE_URL}/get_pdf_sas_token/${blobPath}`, {
            params: {
                filename: fileName,
                inline: inline
            },
            headers: {
                "Content-Type": "application/json",
                withCredentials: true
            }
        })
        .then(res => {
            const data = res.data;
            return data;
        })
        .catch(error => {
            throw error;
        });
}

export function getCitationFilePath(citation: string): string {
    return `/content${citation}`;
}
